module.exports = __webpack_public_path__ + "static/media/sent.4cc267ed.svg";